export const DUMMY = [
  {
    name: 'jadwal',
    type: 'DROPDOWN',
    isRequired: true,
    options: ['daily', 'weekly', 'biweekly'],
  },

  {
    name: 'start_date',
    type: 'DATE_PICKER',
    isRequired: true,
  },
  {
    name: 'file_type',
    type: 'DROPDOWN',
    isRequired: true,
    options: ['PDF', 'CSV', 'XLSX'],
  },
  {
    name: 'email_recipients',
    type: 'MULTIPLE_INPUT',
    isRequired: true,
  },
  {
    name: 'Body Email',
    type: 'AREA_TEXT',
    isRequired: false,
  },
  {
    name: 'status',
    type: 'CHECK_BOX',
    isRequired: true,
    options: ['Option 1', 'Option 2', 'Option 3'],
  },
];

export const DISBURSEMENT_PRODUCT = [
  'API_DISBURSE',
  'BULK_DISBURSEMENT',
  'CLAIM_FUND',
  'INTERNATIONAL_TRANSFER',
];
